import { merge } from 'lodash';
import { Theme } from '@mui/material/styles';
import Fab from 'vendor/material-minimal/overrides/Fab';
import Card from 'vendor/material-minimal/overrides/Card';
import Chip from 'vendor/material-minimal/overrides/Chip';
import Tabs from 'vendor/material-minimal/overrides/Tabs';
import Menu from 'vendor/material-minimal/overrides/Menu';
import Grid from 'vendor/material-minimal/overrides/Grid';
import Lists from 'vendor/material-minimal/overrides/Lists';
import Table from 'vendor/material-minimal/overrides/Table';
import Alert from 'vendor/material-minimal/overrides/Alert';
import Badge from 'vendor/material-minimal/overrides/Badge';
import Paper from 'vendor/material-minimal/overrides/Paper';
import Input from 'vendor/material-minimal/overrides/Input';
import Radio from 'vendor/material-minimal/overrides/Radio';
import Drawer from 'vendor/material-minimal/overrides/Drawer';
import Dialog from 'vendor/material-minimal/overrides/Dialog';
import Avatar from 'vendor/material-minimal/overrides/Avatar';
import Rating from 'vendor/material-minimal/overrides/Rating';
import Slider from 'vendor/material-minimal/overrides/Slider';
import Button from 'vendor/material-minimal/overrides/Button';
import Switch from 'vendor/material-minimal/overrides/Switch';
import Select from 'vendor/material-minimal/overrides/Select';
import SvgIcon from 'vendor/material-minimal/overrides/SvgIcon';
import Tooltip from 'vendor/material-minimal/overrides/Tooltip';
import Popover from 'vendor/material-minimal/overrides/Popover';
import Stepper from 'vendor/material-minimal/overrides/Stepper';
import Pickers from 'vendor/material-minimal/overrides/Pickers';
import Skeleton from 'vendor/material-minimal/overrides/Skeleton';
import Backdrop from 'vendor/material-minimal/overrides/Backdrop';
import Snackbar from 'vendor/material-minimal/overrides/Snackbar';
import Progress from 'vendor/material-minimal/overrides/Progress';
import Timeline from 'vendor/material-minimal/overrides/Timeline';
import Checkbox from 'vendor/material-minimal/overrides/Checkbox';
import Container from 'vendor/material-minimal/overrides/Container';
import Accordion from 'vendor/material-minimal/overrides/Accordion';
import Typography from 'vendor/material-minimal/overrides/Typography';
import Pagination from 'vendor/material-minimal/overrides/Pagination';
import IconButton from 'vendor/material-minimal/overrides/IconButton';
import Breadcrumbs from 'vendor/material-minimal/overrides/Breadcrumbs';
import ButtonGroup from 'vendor/material-minimal/overrides/ButtonGroup';
import Autocomplete from 'vendor/material-minimal/overrides/Autocomplete';
import ToggleButton from 'vendor/material-minimal/overrides/ToggleButton';
import ControlLabel from 'vendor/material-minimal/overrides/ControlLabel';
import LoadingButton from 'vendor/material-minimal/overrides/LoadingButton';
import FormHelperText from 'vendor/material-minimal/overrides/FormHelperText';

// ----------------------------------------------------------------------
// CUSTOM CHANGES
// - deleted TreeView

export default function ComponentsOverrides(theme: Theme) {
  return merge(
    Fab(theme),
    Tabs(theme),
    Chip(theme),
    Card(theme),
    Menu(theme),
    Grid(theme),
    Input(theme),
    Radio(theme),
    Badge(theme),
    Lists(theme),
    Table(theme),
    Paper(theme),
    Alert(theme),
    Switch(theme),
    Select(theme),
    Button(theme),
    Rating(theme),
    Dialog(theme),
    Avatar(theme),
    Slider(theme),
    Drawer(theme),
    Pickers(theme),
    Stepper(theme),
    Tooltip(theme),
    Popover(theme),
    SvgIcon(theme),
    Checkbox(theme),
    Skeleton(theme),
    Timeline(theme),
    Backdrop(theme),
    Snackbar(theme),
    Progress(theme),
    Container(theme),
    Accordion(theme),
    IconButton(theme),
    Typography(theme),
    Pagination(theme),
    ButtonGroup(theme),
    Breadcrumbs(theme),
    Autocomplete(theme),
    ControlLabel(theme),
    ToggleButton(theme),
    LoadingButton(theme),
    FormHelperText(theme),
  );
}
